import { skipToken } from '@reduxjs/toolkit/query';
import { useAppSelector } from 'store/hooks/useApp';
import { useCheckTokenQuery } from 'store/slices/auth/apis/auth';
import { authTokensSelector } from 'store/slices/auth/selectors';

interface UseAuthCheckReturn {
  isAuthenticated: boolean,
  isLoading: boolean,
}

const useAuthCheck = (): UseAuthCheckReturn => {
  const { accessToken } = useAppSelector(authTokensSelector);

  const queryParams = accessToken ? { token: accessToken } : skipToken;
  const { data: checkToken, isLoading } = useCheckTokenQuery(queryParams);

  const { valid } = checkToken?.data || {};
  const isAuthenticated = !!accessToken && !!valid;

  return {
    isAuthenticated,
    isLoading,
  };
};

export default useAuthCheck;
